export const UPDATE_SUBSCRIPTION = 'USER/UPDATE_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION_PENDING = `${UPDATE_SUBSCRIPTION}_PENDING`;
export const UPDATE_SUBSCRIPTION_FULFILLED = `${UPDATE_SUBSCRIPTION}_FULFILLED`;
export const UPDATE_SUBSCRIPTION_REJECTED = `${UPDATE_SUBSCRIPTION}_REJECTED`;

export const updateSubscription = (stripePlanId) => ({
  type: UPDATE_SUBSCRIPTION,
  payload: {
    stripePlanId,
  },
});
